import React, { memo } from 'react';

const COLORS = ['dark', 'light'];

type Props = {
  background?: 'dark' | 'light';
  wide?: boolean;
};

const backgroundToCSS = (background: Props['background']) => {
  switch (background) {
    case 'dark':
      return {
        body: {
          backgroundColor: '#111116',
          color: '#fff',
        },
        a: {
          color: '#fff',
          hoverColor: '#ccc',
        },
      };

    default:
      return {
        body: {
          backgroundColor: '#F4F2F2',
          color: '#111116',
        },
        a: {
          color: '#08c',
          hoverColor: '#005580',
        },
      };
  }
};

export const MainLayout: React.FC<Props> = memo((props) => {
  if (document.body.style) {
    document.body.style.backgroundColor = '';
  }
  COLORS.forEach((color) => {
    document.body.classList.remove(`body--${color}`);
  });
  document.body.classList.add(`body--${props.background}`);
  document.body.classList.toggle(
    'layout--responsive',
    props.wide === undefined ? true : props.wide,
  );
  const css = backgroundToCSS(props.background);

  const styleContent = `
    body {
      background: ${css.body.backgroundColor};
      color: ${css.body.color};
    }
    a {
      color: ${css.a.color};
    }
    a:hover {
      color: ${css.a.hoverColor};
    }
  `;

  return (
    <div className='h-100 d-flex flex-column'>
      <style>{styleContent}</style>
      {props.children}
    </div>
  );
});
